export const IMAGE_BLUR_TYPES = {
  FOREGROUND: 'FOREGROUND',
  BACKGROUND: 'BACKGROUND',
  PHOTO_FOREGROUND_FOREGROUND: 'PHOTO_FOREGROUND_FOREGROUND',
  PHOTO_FOREGROUND_BACKGROUND: 'PHOTO_FOREGROUND_BACKGROUND',
};
